"use client";

import { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import UserNavbarTopLeft from "./UserNavbarTopLeft";
import UserNavbarTopCenter from "./UserNavbarTopCenter";
import UserNavbarTopRight from "./UserNavbarTopRight";
import { Stack } from "@mui/material";
import color from "@/style/theme/Color";
import SubKoleksi from "@/layout/Navbar/Top/Sub/SubKoleksi";
import SubLayanan from "@/layout/Navbar/Top/Sub/SubLayanan";
import SubBantuan from "@/layout/Navbar/Top/Sub/SubBantuan";
import SubTentangKami from "@/layout/Navbar/Top/Sub/SubTentangKami";
import MenuContext from "@/context/MenuProvider";

const UserNavbarTop = () => {
  const { stateAppBar } = useContext(MenuContext)!;

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: color.white_transparent,
          backdropFilter: "blur(10px)",
          color: "#000"
        }}
      >
        <Container>
          <Toolbar disableGutters sx={{ color: "black" }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <UserNavbarTopLeft/>
              <UserNavbarTopCenter/>
              <UserNavbarTopRight/>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
      {stateAppBar["subAppBarLayanan"] && <SubLayanan/>}
      {stateAppBar["subAppBarBantuan"] && <SubBantuan/>}
      {stateAppBar["subAppBarTentangKami"] && <SubTentangKami/>}
    </>
  );
};
export default UserNavbarTop;
